export default function LoadingWidgets() {
  return (
    <div className='container mx-auto'>
      <div className='w-full mx-auto mt-8'>
        <div className='animate-pulse flex flex-col my-4'>
          <div className='space-y-4 py-1'>
            {Array.from(Array(10).keys()).map((_num: number, index: number) => (
              <div key={index} className='space-y-2'>
                <div className='h-24 bg-neutralColor-light rounded p-5'>
                  <div className='h-4 bg-neutralColor-lightest w-1/2 mb-5 rounded'></div>
                  <div className='h-4 bg-neutralColor-lightest w-1/3 mb-5 rounded'></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
